var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkDateFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M18.12 17.37c5.13 1.71 7.665-1.313 7.665-1.313s-11.879-2.565-10.261.916 5.924 3.237 5.924 3.237c6.26-.031 6.505-6.179 6.505-6.179H14.68v-1.405h13.701M13.886 34.451l14.739-.082-.081-1.954H13.967v-2.28h14.658v-2.138H14.211"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.916 5.757v7.398a7.594 7.594 0 01-4.862 7.086l.059 1.866a7.595 7.595 0 014.803 7.063v7.36M13.733 5.796v7.36a7.595 7.595 0 004.803 7.063l.059 1.866a7.595 7.595 0 00-4.862 7.086v7.398M10.799 5.579h21.15"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 18.507,
    cy: 32.126,
    r: 1.445
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.949 36.844h-21.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkDateFilled);
export default __webpack_public_path__ + "static/media/workDateFilled.25e08f3cf34abbbb5f54206c701fb5dd.svg";
export { ForwardRef as ReactComponent };